import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const ArrowUturnLeftSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 2L2 6L6 10M2 6H10C12.2091 6 14 7.79086 14 10C14 12.2091 12.2091 14 10 14H8"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default ArrowUturnLeftSvg
